import { faArrowToBottom, faFilter, faMessage, faTableColumns } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Avatar from '@scoir/avatar'
import { DismissibleDialog } from '@scoir/modals'

import backgroundImage from './headerShape.svg'
import { UnlockPremiumAction } from './tracking'

const useStyles = makeStyles((theme) => ({
  header: {
    background: theme.palette.secondary.main,
    backgroundImage: `url("${backgroundImage}")`,
    backgroundRepeat: 'no-repeat',
    color: theme.palette.common.white,
    minHeight: 180,
    display: 'flex',
    alignItems: 'center',
  },
}))
interface PremiumModalProps {
  open: boolean
  onCancel: () => void
  trackingIdPlacement: UnlockPremiumAction
}

const PremiumModal = ({ open, onCancel, trackingIdPlacement }: PremiumModalProps) => {
  const classes = useStyles()
  return (
    <DismissibleDialog
      open={open}
      onClose={onCancel}
      //   @ts-expect-error - incorrectly typed
      headerText={
        <Box>
          <Typography
            variant="h4"
            component="h3"
          >
            Visits+ Premium is coming soon!
          </Typography>
          <Typography
            variant="h6"
            component="h4"
          >
            Data-driven and relationship-focused recruitment
          </Typography>
        </Box>
      }
      headerClassName={classes.header}
    >
      <DismissibleDialog.Body>
        <Box>
          <ListItem>
            <ListItemIcon>
              <Avatar
                aria-label="Advanced Data Filters & Insights"
                variant="circular"
                size="sm"
                iconColor="secondary"
                fallbackIcon={
                  <FontAwesomeIcon
                    icon={faFilter}
                    size="sm"
                  />
                }
              />
            </ListItemIcon>
            <ListItemText
              primary="Advanced Data Filters & Insights"
              secondary="Discover schools with students who match your recruitment goals and show real interest in what you offer"
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <Avatar
                aria-label="Custom Views & Column Control"
                variant="circular"
                size="sm"
                iconColor="secondary"
                fallbackIcon={
                  <FontAwesomeIcon
                    icon={faTableColumns}
                    size="sm"
                  />
                }
              />
            </ListItemIcon>
            <ListItemText
              primary="Custom Views & Column Control"
              secondary="Customize your table and save your searches to quickly pick up where you left off"
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <Avatar
                aria-label="CRM-Ready Exports"
                variant="circular"
                size="sm"
                iconColor="secondary"
                fallbackIcon={
                  <FontAwesomeIcon
                    icon={faArrowToBottom}
                    size="sm"
                  />
                }
              />
            </ListItemIcon>
            <ListItemText
              primary="CRM-Ready Exports"
              secondary="Reduce manual data entry and import detailed information on thousands of high schools directly into your CRM"
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <Avatar
                aria-label="Enhanced Communications"
                variant="circular"
                size="sm"
                iconColor="secondary"
                fallbackIcon={
                  <FontAwesomeIcon
                    icon={faMessage}
                    size="sm"
                  />
                }
              />
            </ListItemIcon>
            <ListItemText
              primary="Enhanced Communications"
              secondary="Boost visit attendance and reach school counselors at scale"
            />
          </ListItem>
        </Box>
      </DismissibleDialog.Body>
      <DismissibleDialog.Footer>
        <Button
          variant="text"
          color="primary"
          onClick={onCancel}
          size="large"
        >
          Cancel
        </Button>
        <Button
          href={`https://www.scoir.com/colleges/early-access?utm_campaign=12992825-2025%20Visits%20Plus&utm_source=product&utm_medium=modal&utm_content=${encodeURIComponent(
            trackingIdPlacement,
          )}`}
          target="_blank"
          rel="noopener"
          variant="contained"
          color="secondary"
          size="large"
          data-action-id="unlock-premium-hs-explorer-learn-more"
        >
          Learn More
        </Button>
      </DismissibleDialog.Footer>
    </DismissibleDialog>
  )
}

export default PremiumModal
